import { Model } from 'infra/model'
import { computed, makeObservable, observable } from 'mobx'
import { Partial } from 'react-spring'
import { SearchableUserDTO } from '../dtos/searchable-user'
import { Id } from '../../types/definitions'
import { DateZero, maybeParseDate } from '../../utils/date-util'
import { generateAvatarFallback } from '../../utils/image-util'
import { UserDataType } from './UserDataType'
import { match } from '../../utils/pattern-match-util'

export class SearchableUser extends Model<SearchableUserDTO, SearchableUser> {
  @observable publicId = Id.none
  @observable givenName = ''
  @observable familyName = ''
  @observable picture = ''
  @observable email = ''
  @observable userDataType = UserDataType.User
  @observable dateCreated = DateZero()
  @observable lastSeen = DateZero()

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get avatar() {
    return (
      this.picture || generateAvatarFallback(this.displayName || this.email)
    )
  }

  @computed
  get displayName() {
    return `${this.givenName} ${this.familyName}`
  }

  parse(userDTO: Partial<SearchableUserDTO>): Partial<SearchableUser> {
    return {
      publicId: userDTO.public_id,
      userDataType: userDTO.user_data_type
        ? match(userDTO.user_data_type, {
            USER: () => UserDataType.User,
            PRO: () => UserDataType.Pro,
            ADMIN: () => UserDataType.Admin,
            [match.DEFAULT]: () => UserDataType.User,
          })
        : UserDataType.User,
      givenName: userDTO.given_name,
      familyName: userDTO.family_name,
      email: userDTO.email,
      picture: userDTO.picture,
      lastSeen: maybeParseDate(userDTO.last_seen),
      dateCreated: maybeParseDate(userDTO.date_created),
    }
  }
}
